import React, { useState } from "react";
import { Link } from "react-router";
import { HealthCauses } from "@/features/daily/components/command/HealthCauses";
import type { AlertStripVm } from "@/features/daily/components/command/health-view-model";

const PANEL_ID = "daily-alert-causes";

/**
 * D125: one line in place of the hero — severity, the worst live cause and its queue.
 * The full list with the way back to normal is one disclosure away. Polite status, so
 * a figure that moves on the next poll is not shouted over the operator.
 */
export const AlertStrip: React.FC<{ alert: AlertStripVm }> = ({ alert }) => {
    const [open, setOpen] = useState(false);
    return (
        <section className="daily-alert" data-tone={alert.tone} aria-label="Alerta de la plataforma">
            <div className="daily-alert__line" role="status">
                <span className="daily-alert__severity">{alert.severityLabel}</span>
                <span className="daily-alert__title" title={alert.title}>{alert.title}</span>
                {alert.href === null ? null : <Link className="daily-alert__link" to={alert.href}>abrir cola</Link>}
            </div>
            {alert.causes === null ? null : (
                <button
                    type="button"
                    className="daily-alert__toggle"
                    aria-expanded={open}
                    aria-controls={PANEL_ID}
                    onClick={() => setOpen((value) => !value)}
                >
                    {open ? "Ocultar causas" : "Ver causas y cómo normalizar"}
                </button>
            )}
            {alert.causes === null ? null : (
                <div className="daily-alert__panel" id={PANEL_ID} hidden={!open}>
                    <HealthCauses causes={alert.causes} />
                </div>
            )}
        </section>
    );
};
